import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center text-xl"
}
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "table-index-cell" }
const _hoisted_4 = { class: "table-index-cell__order" }
const _hoisted_5 = { class: "table-index-cell__id" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, "ĐVT", -1)
const _hoisted_8 = { class: "d-flex align-items-center mb-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, "Số dư đầu năm", -1)
const _hoisted_10 = { class: "text-end mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Đơn giá")
], -1)
const _hoisted_12 = { class: "text-end mb-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "S/L nhập")
], -1)
const _hoisted_14 = { class: "text-end mb-0" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "d-flex align-items-center mb-0" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Thành tiền")
], -1)
const _hoisted_16 = { class: "text-end mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationApproveDialog = _resolveComponent("ConfirmationApproveDialog")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_VatTuDetailModal = _resolveComponent("VatTuDetailModal")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_Setting = _resolveComponent("Setting")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ConfirmationApproveDialog, {
      "approve-type": "VAT_TU",
      "is-display": !!_ctx.approvingVatTu,
      "vat-tu": _ctx.approvingVatTu ?? undefined,
      onOnClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approvingVatTu = null)),
      onOnConfirm: _cache[1] || (_cache[1] = 
      () => {
        _ctx.approvingVatTu = null;

        _ctx.$emit('on-approve-success');
      }
    )
    }, null, 8, ["is-display", "vat-tu"]),
    _createVNode(_component_ConfirmationDialog, {
      title: "Xác nhận",
      size: "sm",
      "is-display": _ctx.isDeleteVatTuDialogDisplay,
      onOnConfirmButtonClick: _ctx.confirmDelete,
      onOnCloseButtonClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDeleteVatTuDialogDisplay = false)),
      onOnCloseIconClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDeleteVatTuDialogDisplay = false))
    }, {
      default: _withCtx(() => [
        (_ctx.deletingVatTu)
          ? (_openBlock(), _createElementBlock("h4", _hoisted_1, [
              _createTextVNode(" Bạn hãy chắc chắn muốn xóa vật tư "),
              _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.deletingVatTu.ten_vat_tu), 1),
              _createTextVNode("? ")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_VatTuDetailModal, {
      "vat-tu-id": _ctx.selectedVatTuId,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedVatTuId = undefined)),
      onRefresh: _cache[5] || (_cache[5] = 
      () => {
        _ctx.selectedVatTuId = undefined;

        _ctx.$emit('refresh');
      }
    )
    }, null, 8, ["vat-tu-id"]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      "cell-class-name": _ctx.isTextDangerColumn,
      "empty-text": "Chưa có vật tư",
      "max-height": "800",
      size: "medium",
      data: _ctx.vatTuItems,
      border: true,
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "STT",
          width: "70"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.indexCal(scope.$index, _ctx.curPage, _ctx.perPage)), 1),
              _createElementVNode("span", _hoisted_5, "(" + _toDisplayString(scope.row.id) + ")", 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { label: "Tên" }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ten_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Mã",
          width: "120"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.ma_vat_tu), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "Nhóm vật tư",
          width: "250"
        }, {
          default: _withCtx((scope) => [
            (scope.row.danh_muc_vat_tu?.length)
              ? (_openBlock(), _createBlock(_component_BaseLink, {
                  key: 0,
                  to: {
            name: 'chi-tiet-danh-muc-vat-tu',
            params: { id: scope.row.danh_muc_vat_tu[0].id },
          }
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(scope.row.danh_muc_vat_tu[0].ten_danh_muc), 1)
                  ]),
                  _: 2
                }, 1032, ["to"]))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "-"))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, { width: "100" }, {
          header: _withCtx(() => [
            _hoisted_7
          ]),
          default: _withCtx((scope) => [
            _createElementVNode("p", _hoisted_8, _toDisplayString(scope.row.don_vi_tinh ? scope.row.don_vi_tinh : "-"), 1)
          ]),
          _: 1
        }),
        (!_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "Thu hồi",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.vatTuItems[scope.$index].thu_hoi,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].thu_hoi) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "C/ty quản lý",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  modelValue: _ctx.vatTuItems[scope.$index].cong_ty_duyet,
                  "onUpdate:modelValue": ($event: any) => ((_ctx.vatTuItems[scope.$index].cong_ty_duyet) = $event),
                  disabled: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "Trạng thái",
              width: "60"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_checkbox, {
                  "model-value": _ctx.isValid(scope.row),
                  disabled: ""
                }, null, 8, ["model-value"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showSoDu && !_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 3,
              label: "Số dư đầu năm",
              width: "130"
            }, {
              header: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.showSoDu ? _ctx.formatQuantity(scope.row.so_du_dau_nam) : "-"), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.showPrice)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 4,
              width: "150"
            }, {
              header: _withCtx(() => [
                _hoisted_11
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_12, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.showPrice
                ? _ctx.formatUnitPrice(scope.row.don_gia)
                : "-"), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 5,
              width: "150"
            }, {
              header: _withCtx(() => [
                _hoisted_13
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_14, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatQuantity(scope.row.so_luong)), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.vatTuPhieuNhapDetail)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 6,
              width: "150"
            }, {
              header: _withCtx(() => [
                _hoisted_15
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("p", _hoisted_16, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.formatAmount(
                _ctx.calcLineAmount(+scope.row.so_luong, +scope.row.don_gia)
              )), 1)
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          width: "50",
          fixed: "right",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createVNode(_component_Setting, {
              actions: _ctx.getSettingActions(scope.row)
            }, null, 8, ["actions"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["cell-class-name", "data", "row-class-name"])), [
      [_directive_loading, _ctx.isLoading]
    ])
  ], 64))
}